import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { createTag, updateTag, getAllTags } from "./TagService";

export default function TagForm() {
  const [name, setName] = useState("");
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) loadTag();
  }, [id]);

  const loadTag = async () => {
    const tags = await getAllTags();
    const tag = tags.find(t => t.id === id);
    if (tag) setName(tag.tagName);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (id) {
      await updateTag(id, name);
    } else {
      await createTag(name);
    }

    navigate("/expense/tags");
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3>{id ? "Edit Tag" : "Add Tag"}</h3>

      <input
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Tag name"
        required
      />

      <br /><br />

      <button type="submit">Save</button>
      <button type="button" onClick={() => navigate("/expense/tags")}>
        Cancel
      </button>
    </form>
  );
}
